function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useApolloClient, useMutation, useQuery } from "@apollo/client";
import classNames from "classnames";
import React from "react";
import FormControl from "react-bootstrap/FormControl";
import Nav from "react-bootstrap/Nav";
import { MdClose } from "react-icons/md";
import { FilterContext, UserContext } from "../index";
import "./PersonalReviewUsage.css";
import { APPS_QUERY, APP_PRODUCTIVITY_STATUS_MUTATION } from "./query";
var AppsList = /*#__PURE__*/React.memo(function AppsList(props) {
  var _organisations$;
  var organisations = props.user.organisations,
    team = props.team;
  var organisationId = organisations === null || organisations === void 0 ? void 0 : (_organisations$ = organisations[0]) === null || _organisations$ === void 0 ? void 0 : _organisations$.id;
  var teamId = team === null || team === void 0 ? void 0 : team.id;
  var apolloClient = useApolloClient();
  var _useQuery = useQuery(APPS_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId
      }
    }),
    appsData = _useQuery.data,
    appsError = _useQuery.error,
    appsLoading = _useQuery.loading;
  var _useMutation = useMutation(APP_PRODUCTIVITY_STATUS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addAppProductivityStatus = _useMutation2[0],
    statusChangeLoading = _useMutation2[1].loading;
  var handleStatusChange = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(app) {
      var appName, appCategory, appType, productivityStatus, _app$canBeIdle, _response$data, response, updatedApp, _apolloClient$readQue, prevApps, newApps;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            appName = app.appName, appCategory = app.appCategory, appType = app.appType, productivityStatus = app.productivityStatus;
            _context.prev = 1;
            _context.next = 4;
            return addAppProductivityStatus({
              variables: {
                appName: appName,
                appType: appType,
                appCategory: appCategory,
                productivityStatus: productivityStatus,
                organisationId: organisationId,
                teamId: teamId,
                canBeIdle: (_app$canBeIdle = app.canBeIdle) !== null && _app$canBeIdle !== void 0 ? _app$canBeIdle : false
              }
            });
          case 4:
            response = _context.sent;
            updatedApp = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.addAppProductivityStatus;
            if (updatedApp) {
              _context.next = 8;
              break;
            }
            throw new Error("something went wrong");
          case 8:
            try {
              _apolloClient$readQue = apolloClient.readQuery({
                query: APPS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId
                }
              }), prevApps = _apolloClient$readQue.apps;
              newApps = prevApps.map(function (a) {
                if (a.title === appName) {
                  return _objectSpread(_objectSpread({}, a), {}, {
                    productivityStatus: updatedApp === null || updatedApp === void 0 ? void 0 : updatedApp.productivityStatus
                  });
                }
                return a;
              });
              apolloClient.writeQuery({
                query: APPS_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId
                },
                data: {
                  apps: newApps
                }
              });
            } catch (error) {
              console.log("error on cache update");
            }
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.log("something went wrong");
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 11]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [addAppProductivityStatus]);
  if (appsLoading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (appsError) {
    return /*#__PURE__*/React.createElement("div", null, "Error...");
  }
  if (!appsData) {
    return null;
  }
  var apps = appsData.apps;
  return /*#__PURE__*/React.createElement("div", {
    className: "par-listing"
  }, apps.map(function (app) {
    return /*#__PURE__*/React.createElement(App, _extends({
      key: app.title
    }, app, {
      loading: statusChangeLoading,
      onStatusChange: handleStatusChange
    }));
  }));
});
var PersonalReviewUsage = function PersonalReviewUsage(props) {
  var LinkComponent = props.linkComponent;
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    team = _React$useContext2.team;
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-app-review"
  }, /*#__PURE__*/React.createElement("div", {
    className: "par-list"
  }, /*#__PURE__*/React.createElement(Nav, {
    className: "par-list-tab-bar",
    transition: true,
    activeKey: "Apps",
    defaultActiveKey: "Apps"
  }, /*#__PURE__*/React.createElement(Nav.Item, {
    className: "active"
  }, /*#__PURE__*/React.createElement(Nav.Link, {
    eventKey: "Apps"
  }, "Apps")), /*#__PURE__*/React.createElement(LinkComponent, {
    to: "/",
    className: "par-close-btn"
  }, /*#__PURE__*/React.createElement(MdClose, null))), /*#__PURE__*/React.createElement("div", {
    className: "par-list-by-tabs"
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: "par-list-by-tabs-search",
    placeholder: "Search Apps"
  }), /*#__PURE__*/React.createElement("div", {
    className: "par-legend"
  }, ["Productive", "Neutral", "Unproductive"].map(function (s) {
    return /*#__PURE__*/React.createElement("div", {
      key: "legend-".concat(s),
      className: classNames("par-legend-item", "pl-".concat(s.toLowerCase()))
    }, /*#__PURE__*/React.createElement("div", {
      className: "par-legend-icon"
    }, s.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "par-legend-name"
    }, s));
  })), /*#__PURE__*/React.createElement(AppsList, {
    user: user,
    team: team
  }))));
};
export default PersonalReviewUsage;
var App = /*#__PURE__*/React.memo(function App(props) {
  var title = props.title,
    appType = props.appType,
    appCategory = props.appCategory,
    icon = props.icon,
    productivityStatus = props.productivityStatus,
    onStatusChange = props.onStatusChange,
    loading = props.loading;
  var _React$useState = React.useState(productivityStatus || "neutral"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    status = _React$useState2[0],
    setStatus = _React$useState2[1];
  var handleStatusChange = function handleStatusChange(s) {
    return function () {
      if (loading || productivityStatus === "productive" || productivityStatus === "unproductive") {
        return;
      }
      onStatusChange({
        appName: title,
        appType: appType,
        appCategory: appCategory,
        productivityStatus: s
      });
      setStatus(s);
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "par-listing-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "par-lc-content"
  }, /*#__PURE__*/React.createElement("img", {
    className: "par-lc-content-icon",
    src: icon || "https://img.icons8.com/color/344/visual-studio-code-2019.png"
  }), /*#__PURE__*/React.createElement("div", {
    className: "par-lc-content-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "par-lc-content-app-name"
  }, title || "Unknown"), appCategory ? /*#__PURE__*/React.createElement("div", {
    className: "par-lc-content-app-category"
  }, appCategory) : null)), /*#__PURE__*/React.createElement("div", {
    className: "par-lc-button"
  }, ["productive", "neutral", "unproductive"].map(function (s) {
    var initial = s.charAt(0).toUpperCase();
    var selected = status === s;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("par-lc-button-state", _defineProperty(_defineProperty(_defineProperty({}, "par-".concat(s), true), "selected", selected), "loading", loading)),
      onClick: !loading ? handleStatusChange(s) : null
    }, initial);
  })));
});

// const tabs = ["Categories", "Apps & Websites"];
// const tabsComponent = {
//   // Categories: CategoriesList,
//   "Apps & Websites": AppsList,
// };

// const CategoriesList = React.memo(function CategoriesList(props) {
//   const {
//     user: { organisations },
//     team,
//   } = props;

//   const organisationId = organisations?.[0]?.id;
//   const teamId = team?.id;

//   const apolloClient = useApolloClient();

//   const { data: categoriesData, error: categoriesError, loading: categoriesLoading } = useQuery(CATEGORIES_QUERY, {
//     variables: { organisationId, teamId },
//   });

//   const [addCategoryProductivityStatus, { loading: statusChangeLoading }] = useMutation(
//     CATEGORY_PRODUCTIVITY_STATUS_MUTATION
//   );

//   const handleStatusChange = React.useCallback(
//     async (category) => {
//       const { categoryName, productivityStatus } = category;
//       try {
//         const response = await addCategoryProductivityStatus({
//           variables: {
//             categoryName,
//             productivityStatus,
//             organisationId,
//             teamId,
//             canBeIdle: category.canBeIdle ?? false,
//           },
//         });

//         const updatedCategory = response?.data?.addCategoryProductivityStatus;

//         if (!updatedCategory) {
//           throw new Error("something went wrong");
//         }

//         try {
//           const { categories: prevCategories } = apolloClient.readQuery({
//             query: CATEGORIES_QUERY,
//             variables: {
//               organisationId,
//               teamId,
//             },
//           });

//           const newCategories = prevCategories.map((c) => {
//             if (c.name === categoryName) {
//               return {
//                 ...c,
//                 productivityStatus: updatedCategory?.productivityStatus,
//               };
//             }
//             return c;
//           });

//           apolloClient.writeQuery({
//             query: CATEGORIES_QUERY,
//             variables: {
//               organisationId,
//               teamId,
//             },
//             data: {
//               categories: newCategories,
//             },
//           });
//         } catch (error) {
//           console.log("error on cache update");
//         }
//       } catch (error) {
//         console.log("something went wrong");
//       }
//     },
//     [addCategoryProductivityStatus]
//   );

//   if (categoriesLoading) {
//     return <div>Loading...</div>;
//   }

//   if (categoriesError) {
//     return <div>Error...</div>;
//   }

//   if (!categoriesData) {
//     return null;
//   }

//   const { categories } = categoriesData;

//   return (
//     <div className="par-listing">
//       {categories.map((category) => {
//         return (
//           <Category
//             key={category.name}
//             {...category}
//             loading={statusChangeLoading}
//             onStatusChange={handleStatusChange}
//           />
//         );
//       })}
//     </div>
//   );
// });

// const categories = [
//   "Business",
//   "Streaming Media",
//   "File Sharing",
//   "Technology & Computing",
//   "Business",
//   "Streaming Media",
//   "File Sharing",
//   "Technology & Computing",
//   "Business",
//   "Streaming Media",
//   "File Sharing",
//   "Technology & Computing",
// ];

// const apps = [
//   "app.slack.com",
//   "youtube.com",
//   "drive.google.com",
//   "stackoverflow.com",
//   "app.slack.com",
//   "youtube.com",
//   "drive.google.com",
//   "stackoverflow.com",
//   "app.slack.com",
//   "youtube.com",
//   "drive.google.com",
//   "stackoverflow.com",
// ];

// const Category = React.memo(function Category(props) {
//   const { name, productivityStatus, onStatusChange, loading } = props;

//   const initalStatus = productivityStatus || "neutral";

//   const handleStatusChange = (s) => () => {
//     if (loading || productivityStatus === "productive" || productivityStatus === "unproductive") {
//       return;
//     }

//     onStatusChange({
//       categoryName: name,
//       productivityStatus: s,
//     });
//   };

//   return (
//     <div className="par-listing-card">
//       <div className="par-lc-content">
//         <div className="par-lc-content-avatar">{name?.charAt(0)}</div>
//         <div className="par-lc-content-name">
//           <div className="par-lc-content-app-name">{name}</div>
//         </div>
//       </div>
//       <div className="par-lc-button">
//         {["productive", "neutral", "unproductive"].map((s) => {
//           const initial = s.charAt(0).toUpperCase();
//           const selected = initalStatus === s;
//           return (
//             <div
//               className={classNames("par-lc-button-state", {
//                 [`par-${s}`]: true,
//                 selected,
//                 loading,
//               })}
//               onClick={!loading ? handleStatusChange(s) : null}
//             >
//               {initial}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// });